/**
 * Created by Caroline on 2019/11/25 0025.
 *
 */
import axios from 'axios'
import * as types from './types'

export const updateMode = ({ commit }, mode) => {
  commit(types.UPDATE_MODE, {
    payload: {
      modeData: mode
    }
  })
  commit(types.UPDATE_TAGS, {
    payload: {
      tags: mode.albumConfig.tags
    }
  })
}
export const addBlessing = ({ commit }, blessing) => {
  commit(types.ADD_BLESSING, {
    payload: {
      newBlessing: blessing
    }
  })
}
export const updateLottery = ({ commit }, lottery) => {
  commit(types.UPDATE_LOTTERY, {
    payload: {
      lottery: lottery,
    }
  })
}
export const sendMode = ({ commit }, mode) => {
  commit(types.SEND_MODE, {
    payload: {
      mode: mode
    }
  })
}

export const getActivityId = ({ commit, rootState }, payload) => {
  return new Promise((resolve, reject) => {
    let req = axios.get(rootState.host.wl + '/activity/randomString/' + payload + '?' + rootState.reqVersion)
    req.then(res => {
      // console.log("randomString ", res.data.data)
      commit(types.GET_ACTIVITY_ID, {
        payload: {
          id: res.data.data.activity.id,
        }
      })
      commit(types.GET_LIVE_DETAIL, {
        payload: {
          detail: res.data.data,
        }
      })
      resolve(res.data.data)
    }).catch(err => {
      console.log(err)
      reject()
    })
  })
}
export const setActivityId = ({ commit }, id) => {
  commit(types.SET_ACTIVITY_ID, {
    payload: {
      id: id
    }
  })
}
export const getLiveDetail = ({ commit, rootState }, payload) => {
  let req = axios.get(rootState.host.wl + '/activity/' + rootState.activityId + '?' + rootState.reqVersion)
  req.then(res => {
    commit(types.GET_LIVE_DETAIL, {
      payload: {
        detail: res.data.data,
      }
    })
  }).catch(err => {
    console.log(err)
  })
}
export const getShareData = ({ commit, rootState }, payload) => {
  let req = axios.get(rootState.host.wl + '/activity/' + rootState.activityId + '/share?' + rootState.reqVersion)
  req.then(res => {
    commit(types.GET_SHARE_DATA, {
      payload: {
        shareData: res.data.data,
      }
    })
  }).catch(err => {
    console.log(err)
  })
}

export const getImageList = ({ dispatch, commit, rootState }, payload) => {
  // console.log("getImageList", payload);
  return new Promise((resolve, reject) => {
    let tagIdsStr = rootState.tagIds.toString()
    let req = axios.get(rootState.host.wl + '/image/list/filter?activityId=' + rootState.activityId
      + '&tags=' + tagIdsStr
      + '&showUserImage=' + rootState.modeData.albumConfig.showUserImage
      + '&' + rootState.reqVersion)
    req.then(res => {
      if (res.data.status) {
        let imageList = res.data.data.map(item => item.fileName + '?imageView2/2/w/1920/h/1080/q/95')
        commit(types.GET_IMAGE_LIST, {
          payload: {
            imageList: imageList,
          }
        })
        resolve(imageList)
      } else {
        reject()
      }
    }).catch(err => {

      console.log(err)
      reject(err)
    })
  })

}

export const getAllBlessingList = ({ dispatch, commit, rootState }, payload) => {
  let param = {
    wl: rootState.host.wl,
    activityId: rootState.activityId,
    start: 0,
    count: 20,
    blessingList: [],
    blessingData: {
      qrcodeUrl: '',
      total: 0,
    },
  }
  dispatch('getBlessingListLoop', param)
}
export const getBlessingListLoop = ({ dispatch, commit, rootState }, payload) => {
  dispatch('getBlessingListRequest', payload).then(res => {
    // console.log("res", res);
    payload.blessingList = payload.blessingList.concat(res.blessingList)
    payload.start = payload.blessingList.length
    if (payload.blessingList.length < res.total) {
      dispatch('getBlessingListLoop', payload)
    } else {
      let list = payload.blessingList
      // let blessingPreset = payload.blessingList.shift()
      // let list = payload.blessingList.reverse()
      // list.unshift(blessingPreset)
      // console.log("list", list);
      commit(types.GET_BLESSING_LIST, {
        payload: {
          blessingList: list,
          blessingData: {
            qrcodeUrl: res.qrcodeUrl,
            total: res.total,
          },
        }
      })
    }
  }).catch(err => {
    const { blessingList, blessingData } = rootState
    commit(types.GET_BLESSING_LIST, {
      payload: {
        blessingList: blessingList,
        blessingData: blessingData
      }
    })
  })
}
export const getBlessingListRequest = ({ commit, rootState }, payload) => {
  return new Promise((resolve, reject) => {
    let req = axios.get(payload.wl + '/blessing/list?activityId=' + rootState.activityId
      + '&start=' + payload.start
      + '&count=' + payload.count
      + '&' + rootState.reqVersion)
    req.then(res => {
      if (res.data.status) {
        resolve(res.data.data)
      } else {
        reject()
      }
    }).catch(err => {
      console.log(err)
      reject(err)
    })
  })
}
export const updateBlessingListByNew = ({ commit, rootState }, payload) => {
  commit(types.UPDATE_BLESSING_LIST_BY_NEW, {
    payload: {
      newList: payload
    }
  })
}

export const getLottery = ({ commit, rootState }, payload) => {
  let req = axios.get(rootState.host.wl + 'weddinglive/activity/' + rootState.activityId + '?' + rootState.reqVersion)
  req.then(res => {
    console.log("res", res);
    commit(types.GET_LOTTERY, {
      payload: {
        lottery: res.data.data,
      }
    })
  }).catch(err => {
    console.log(err)
  })
}

export const windowResize = ({ commit, rootState }, payload) => {
  // console.log("windowResize",);
  commit(types.UPDATE_WINDOW_SIZE, {
    payload: {
      winWidth: window.innerWidth,
      winHeight: window.innerHeight,
    }
  })

}

export const showToast = ({ commit, rootState }, payload) => {
  commit(types.SHOW_TOAST, {
    payload: {
      toast: {
        show: true,
        content: payload || rootState.toast.content,
      },
    }
  })
}
export const hideToast = ({ commit, rootState }, payload) => {
  commit(types.HIDE_TOAST, {
    payload: {
      toast: {
        show: false,
        content: rootState.toast.content,
      },
    }
  })
}
export const setGlobalFont = ({ commit }, payload) => {
  // console.log(payload)
  commit(types.UPDATE_GLOBAL_FONT, {
    payload: payload
  })
}



// WEBPACK FOOTER //
// ./src/store/actions.js